const PROD_API_DOMAIN = "https://app.graviz.app/api/v1";
const DEV_API_DOMAIN = "https://app.graviz.app/api/v1"; //"http://127.0.0.1:4000/api/v1";

export const DOMAIN =
  process.env.REACT_APP_API_DOMAIN ||
  (process.env.NODE_ENV === "development" ? DEV_API_DOMAIN : PROD_API_DOMAIN);
export const EMAIL = "support@graviz.app";
export const TELEGRAM_BOT_LINK = "https://t.me/GravizappSupportBot";
export const TELEGRAM_BOT_NAME = "@GravizappBot";
export const TELEGRAM_SUPPORT_BOT_LINK = "https://t.me/GravizappSupportBot";
export const TELEGRAM_SUPPORT_BOT_NAME = "@GravizappSupportBot";
